import styled from 'styled-components'

export const EmptyStateStyles = styled.div`
  &.broken {
    margin: 96px auto;
    width: 296px;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }
  .broken__title {
    margin-top: var(--spacing-margin-large);
  }
  .broken__subtitle {
    margin-top: var(--spacing-margin-xSmall);
  }
  .broken__go-home-btn {
    margin-top: var(--spacing-margin-large);
    width: 100%;
  }
  @media screen and (max-width: 576px) {
    &.broken {
      margin: 48px auto;
    }
  }
`
